import React, { useMemo } from 'react';
import { Frame, SageClassnames, Tooltip, Icon, SageTokens } from '@kajabi/sage-react';

import { useCheckout } from '../../context';

export const Header = () => {
  const {
    planInfo: {
      cardless,
      free_plan: freePlan,
      subtitle,
      title,
      trial_days: trialDays,
      credit_card_validation_disclaimer: creditCardValidationDisclaimer,
    },
    tax,
    isTwoStepsSignupFirstStep,
  } = useCheckout();

  const renderTaxText = () => {
    if (isTwoStepsSignupFirstStep() || cardless || freePlan) {
      return null;
    }

    return (
      <p
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: taxText }}
        style={{ display: 'inline-block' }}
        className={`${SageClassnames.TYPE.BODY_SMALL} ${SageClassnames.TYPE_ALIGN_CENTER}`}
      />
    );
  };

  const taxText = useMemo(
    () => (tax ? `+ ${tax} sales tax estimate` : '+ applicable taxes'),
    [tax],
  );

  const withTitle = () => {
    if (isTwoStepsSignupFirstStep()) {
      if (trialDays && Number(trialDays) > 0) {
        return `Start your ${trialDays}-day free trial`;
      }
      return 'Start Your Journey Today';
    }

    return title;
  };

  const withSubtitle = () => {
    if (isTwoStepsSignupFirstStep() || !subtitle) {
      return null;
    }

    return (
      <h6
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: subtitle }}
        style={{ textAlign: 'center', display: 'inline-block' }}
        className={SageClassnames.TYPE.HEADING_6}
      />
    );
  };

  return (
    <Frame
      align={Frame.ALIGNMENTS.TOP_CENTER}
      className="marketing-signup__header"
      gap={Frame.GAPS.XS}
    >
      <h3 className={SageClassnames.TYPE.HEADING_3}>{withTitle()}</h3>
      <span>
        {withSubtitle()} {renderTaxText()}
        {creditCardValidationDisclaimer && (
          <Tooltip
            content={
              <p className={SageClassnames.TYPE.BODY_SMALL}>{creditCardValidationDisclaimer}</p>
            }
            className={SageClassnames.SPACERS.XS_LEFT}
            style={{ position: 'relative', top: '2px' }}
            position={Tooltip.POSITIONS.RIGHT}
          >
            <Icon icon={SageTokens.ICONS.INFO_CIRCLE} />
          </Tooltip>
        )}
      </span>
    </Frame>
  );
};
